import { useNavigate } from "react-router-dom";
import SectionHeader from "@/components/base/SectionHeader";

const categories = [
  {
    title: "Web Application Development",
    description: "C#, .NET, SQL Server, HTML/CSS/JavaScript, application analysis, development, testing, and support.",
  },
  {
    title: "SharePoint & Collaboration Portals",
    description: "SharePoint administration, templates, master pages, Power Platform, integration, and training.",
  },
  {
    title: "Government Application Support",
    description: "Long-duration public-sector delivery, enhancements, administration, reporting, and technical deliverables.",
  },
  {
    title: "Database Systems & Data Migration",
    description: "SQL Server, database applications, content/data migration, integration, and reporting.",
  },
  {
    title: "Enterprise Application Development",
    description: "Full SDLC, .NET/MVC, Angular, JavaScript, SQL, testing, and production support.",
  },
  {
    title: "CMS Modernization & Web Redesign",
    description: "Web design/development capabilities exist, but a recent public-facing portfolio and direct CMS proof are needed.",
  },
];

export default function ProjectTypesSection() {
  const navigate = useNavigate();

  return (
    <section className="section-padding bg-background-50">
      <div className="container-page">
        <SectionHeader
          title="Types We Pursue"
          subtitle="Bid Categories"
          description="A practical map of where Mitaja can bid, which capabilities support each category, and what must be in place before pursuit."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <div
              key={cat.title}
              className="card-base p-6 hover:border-primary-300 transition-all duration-300"
            >
              <h3 className="text-lg font-bold text-foreground-900 mb-2">
                {cat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <button
            onClick={() => { navigate("/resources/project-types"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            className="btn-primary"
          >
            View All Types & Ratings
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}